/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {genericGetMessages} from '../api'

export const useMutationGenericGetMessages = createReactQueryMutationHook('genericGetMessages', genericGetMessages)
